(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    'use strict';

    // ── Shared date helper ────────────────────────────────────────────────────
    function getMinDate() {
      const d = new Date();
      d.setDate(d.getDate() + 2);
      const pad = n => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    }

    // ── Re-render the full cart section from Shopify ──────────────────────────
    // Only called after item quantity / removal changes (NOT after attribute saves)
    function rerenderCartSection() {
      const cartPage = document.querySelector('.cart-page');
      if (!cartPage) return;

      cartPage.style.opacity = '0.5';
      const section = cartPage.closest('.shopify-section');
      const sectionId = section ? section.id.replace('shopify-section-', '') : 'cart';

      fetch('/cart?section_id=' + sectionId)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newInner = doc.querySelector('.cart-page__inner');
          const currentInner = document.querySelector('.cart-page__inner');

          const oldAccordion = currentInner ? currentInner.querySelector('.cart-page__accordion') : null;
          const wasOpen = oldAccordion && oldAccordion.hasAttribute('open');
          const activeId = document.activeElement ? document.activeElement.id : null;

          if (currentInner && newInner) {
            currentInner.innerHTML = newInner.innerHTML;

            if (wasOpen) {
              const a = currentInner.querySelector('.cart-page__accordion');
              if (a) a.setAttribute('open', '');
            }

            if (activeId) {
              const el = document.getElementById(activeId);
              if (el) {
                const len = el.value ? el.value.length : 0;
                el.focus();
                if (el.setSelectionRange) el.setSelectionRange(len, len);
              }
            }

            // Re-apply date min + default after every re-render
            const newDateEl = currentInner.querySelector('.cart-page__input--date');
            applyDateDefaults(newDateEl);
            if (window.initWildRoseDatePickers) window.initWildRoseDatePickers();
            
            // Re-attach the direct change listener to the new element
            if (newDateEl) {
              newDateEl.addEventListener('change', function() {
                if (newDateEl.value) saveAttributes({ 'Delivery Date': newDateEl.value });
              });
            }
          }
        })
        .catch(err => console.error('[Cart] Section re-render error:', err))
        .finally(() => { cartPage.style.opacity = '1'; });
    }

    // ── Apply min + default to a date input (safe anywhere) ──────────────────
    function applyDateDefaults(dateEl) {
      if (!dateEl) return;
      const minDate = getMinDate();
      dateEl.setAttribute('min', minDate);
      if (!dateEl.value) dateEl.value = minDate;
    }

    // ── Save cart attributes silently (no full page re-render) ────────────────
    function saveAttributes(attributes) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes })
      })
      .then(res => {
        if (res.status === 429) throw new Error('429');
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(cart => {
        // Sync drawer badge / subtotal without a full page re-render
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return cart;
      })
      .catch(err => {
        if (err.message === '429') console.warn('[Cart] Rate limited — attributes not saved');
        else console.error('[Cart] Attribute save error:', err);
      });
    }

    // ── Update item quantity (triggers re-render since prices change) ─────────
    function updateQty(updates) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      })
      .then(res => {
        if (res.status === 429) throw new Error('429');
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(cart => {
        // Quantity changes affect prices → broadcast for badge/drawer sync
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        // Re-render the full section so totals update
        rerenderCartSection();
      })
      .catch(err => {
        if (err.message === '429') console.warn('[Cart] Rate limited on qty update');
        else console.error('[Cart] Qty update error:', err);
      });
    }

    // ── Read all attribute fields from a form into a plain object ─────────────
    function readAttributes(form) {
      const formData = new FormData(form);
      const attrs = {};
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('attributes[')) {
          const m = key.match(/\[([^\]]+)\]/);
          if (m && m[1]) attrs[m[1]] = value;
        }
      }
      return attrs;
    }

    // ── Quantity stepper (click) ──────────────────────────────────────────────
    let qtyDebounceTimer;
    document.addEventListener('click', function (e) {
      // Remove button
      const removeBtn = e.target.closest('.cart-page__item-remove, .cart-page__item-remove-mobile');
      if (removeBtn) {
        e.preventDefault();
        const wrap = removeBtn.closest('.cart-page__item')?.querySelector('.cart-page__qty');
        const itemKey = wrap ? wrap.dataset.itemKey : null;
        if (itemKey) {
          clearTimeout(qtyDebounceTimer);
          updateQty({ [itemKey]: 0 });
        } else {
          console.error('[Cart] Could not find item key for remove button — item not removed', removeBtn);
        }
        return;
      }

      // +/- buttons
      const btn = e.target.closest('.cart-page__qty-btn');
      if (!btn) return;
      e.preventDefault();

      const wrap = btn.closest('.cart-page__qty');
      if (!wrap) return;
      const input = wrap.querySelector('.cart-page__qty-input');
      if (!input) return;

      let val = parseInt(input.value, 10) || 0;
      val = btn.dataset.action === 'increment' ? val + 1 : Math.max(0, val - 1);
      input.value = val;

      const itemKey = wrap.dataset.itemKey;
      if (itemKey) {
        clearTimeout(qtyDebounceTimer);
        qtyDebounceTimer = setTimeout(() => updateQty({ [itemKey]: val }), 400);
      }
    });

    // ── Attribute auto-save (text/textarea → debounced) ───────────────────────
    let debounceTimer;
    document.addEventListener('input', function(e) {
      const form = e.target.closest('#CartPageForm');
      if (!form) return;
      if (e.target.type === 'text' || e.target.tagName === 'TEXTAREA') {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => saveAttributes(readAttributes(form)), 800);
      }
    });

    // ── Attribute auto-save (date/checkbox → instant) ─────────────────────────
    document.addEventListener('change', function(e) {
      const form = e.target.closest('#CartPageForm');
      if (!form) return;

      if (e.target.type === 'checkbox' || e.target.type === 'radio' ||
          e.target.tagName === 'SELECT' || e.target.type === 'date') {
        saveAttributes(readAttributes(form));
      }

      // Direct qty input edit (user types into the number box)
      if (e.target.classList.contains('cart-page__qty-input')) {
        const wrap = e.target.closest('.cart-page__qty');
        const itemKey = wrap ? wrap.dataset.itemKey : null;
        if (itemKey) updateQty({ [itemKey]: parseInt(e.target.value, 10) || 0 });
      }
    });

    // ── Delivery Date: set min attribute + visual fallback ──────────────────────
    // Liquid handles the default value via | default: min_date.
    // JS just enforces the min constraint and directly saves on date select.
    (function initDeliveryDate() {
      const el = document.getElementById('cart-page-delivery-date');
      if (!el) return;
      const minDate = getMinDate(); // JS-computed for timezone accuracy
      el.setAttribute('min', minDate);
      if (!el.value) el.value = minDate; // visual fallback only

      // Direct listener on the element — most reliable way to catch date selection.
      // This is separate from the delegated change listener so it definitely fires.
      el.addEventListener('change', function() {
        if (el.value) saveAttributes({ 'Delivery Date': el.value });
      });
    })();

    // ── Listen for cart:updated — sync badge, subtotal, drawer (NOT re-render) ─
    // Re-renders are ONLY done by rerenderCartSection(), called from updateQty().
    // Attribute saves call saveAttributes() which dispatches cart:updated for
    // badge/drawer sync only. This listener does NOT re-render the full section.
    window.addEventListener('cart:updated', function() {
      // Nothing to do on the cart page itself — the drawer listener handles badge/subtotal.
      // We intentionally do NOT call rerenderCartSection() here for attribute changes.
    });

    // ── Custom checkout validation — scroll + shake if no date selected ───────
    // Intercepts the checkout submit to show a polished error instead of the
    // browser's generic native "Please fill in this field" popup.
    (function initCheckoutValidation() {
      const form = document.getElementById('CartPageForm');
      if (!form) return;

      form.addEventListener('submit', function(e) {
        const dateInput = document.getElementById('cart-page-delivery-date');
        if (!dateInput || dateInput.value) return; // date is set — let form proceed normally

        // Block submission
        e.preventDefault();

        // Find the Flatpickr alt input (the visible one) for the glow/shake animation
        const altInput = dateInput.nextElementSibling; // Flatpickr inserts alt input right after
        const targetEl = (altInput && altInput.classList.contains('cart-page__input--date'))
          ? altInput : dateInput;

        // Apply glow + shake
        targetEl.classList.remove('date-input--invalid'); // reset so animation replays
        void targetEl.offsetWidth; // force reflow to restart animation
        targetEl.classList.add('date-input--invalid');
        setTimeout(() => targetEl.classList.remove('date-input--invalid'), 600);

        // Scroll the field into view smoothly
        const field = dateInput.closest('.cart-page__field') || dateInput.parentElement;
        field && field.scrollIntoView({ behavior: 'smooth', block: 'center' });

        // Show a brief inline error message below the hint
        let errMsg = document.getElementById('cart-page-date-error');
        if (!errMsg) {
          errMsg = document.createElement('p');
          errMsg.id = 'cart-page-date-error';
          errMsg.style.cssText = 'font-size:0.75rem;color:var(--destructive,#d4183d);margin-top:0.25rem;font-weight:600;';
          field && field.appendChild(errMsg);
        }
        errMsg.textContent = '⚠️ Please select a delivery date before checking out.';
        errMsg.style.display = 'block';
        setTimeout(() => { if (errMsg) errMsg.style.display = 'none'; }, 4000);
      });
    })();

  })();

  } catch(e) { console.error(e); }
})();
})();
